<!-- 弹框 公共模板-->

<template>
<el-dialog title  :append-to-body="appendToBody" :modal-append-to-body="modalAppendToBody" :show-close="false" :top="defaultTop" :close-on-click-modal="false" custom-class="vistable_dialog" :visible.sync="openCardDialog" :width="diaWidth" style="background:rgba(0,0,0,.65)">
  <div class="outside_box">
    <div :class="[types == 'login' && 'login_bg',types == 'signup' && 'signup_bg','box-bg']">
      <div class="closelogin-box" v-if="types" style="padding:10px 0">
        <div class="close-btn">
          <div class="logo-show"><img src="../../assets/images/common/logo.png" alt width="100%" height="auto"/></div>
          <div @click="closeDiaLog" class="closelogin"></div>
        </div>
        <div class="diatitle"> <span>{{ $t(diaTitle)}}</span></div>
        <!-- <div class="logo-show"><img src="../../assets/images/common/logo.png" alt width="100%" height="auto"/></div> -->
      </div>

      <div v-else :class="['closelogin-box', 'other-box']">
        <div v-if="types == 'signup'"><img src="../../assets/images/common/logo.png" alt /></div>
        <div :style="{ 'color':iscolor}" style="padding-top:15px;">
          <span v-if="deposit == 'marquee'"><img src="./marquee/img/_white.png" alt style="margin-top:-3px;"/></span>
          <span>{{ $t(diaTitle)}}</span>
        </div>
        <div @click="closeDiaLog" class="otherclose"></div>
      </div>

      <div class="dia-content">
        <slot></slot>
      </div>
    </div>
  </div>
</el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    diaWidth: {
      type: String,
      default: "30%",
    },
    diaTitle:{
        type: String,
        required: false,
    },
    visible:{
        type:Boolean,
        default:false
    },
    types:{
        type:String,
        default:''
    },
    iscolor:{
      type:String,
      default:''
    },
    defaultTop:{
      type:String,
      default:'12vh'
    },
    deposit:{
      type:String,
      default:''
    },
    appendToBody:{
      type:Boolean,
      default:false
    },
    modalAppendToBody:{
      type:Boolean,
      default:true
    }
  },
  computed: {
    ...mapState({
        UUID: state => state.UUID,
    }),
    openCardDialog:{
        get(){
            return this.visible
        },
        set(val){
            this.$emit('update:visible',val)
        }
    }
  },
  methods: {
     closeDiaLog(){
        if(this.types) return this.$emit('handleCloseDialog')
        if(this.deposit == 'deposit') return this.$emit('handeLeClose')
        this.openCardDialog = !this.openCardDialog
     },
  },
};
</script>

<style scoped lang="scss">
$border:6px;
@mixin common_1($val:20px){
  color: #fff;
  font-size: $val;
  font-weight: 800;
  font-family: Roboto-Black;
}
@mixin common_2{
  width: 32px;
  height: 32px;
  background-image: url('../../assets/images/common/close.png');
  background-size: contain;
  cursor: pointer;
  transition: all 200ms;
  &:hover{ transform: rotate(90deg); }
}

@mixin common_3{
  display:flex;
  justify-content: space-between;
}
@mixin _bg{ 
 background-repeat: no-repeat;
    background-size: cover;
}
.vistable_dialog {
  .diatitle {
    width: 100%;
    position: relative;
    @include common_1;
    text-align: center;
  }
  
  .box-bg {
    height: 100%;
    position: relative;
    margin:0 auto;
    width:100%;
    background-color:#fff;
    border-radius: 6px;
    // &.signup_bg{  
      // background-image:url('./img/signup_bg.png');
      // @include _bg;
      // background:#fff;
      // border-radius: 12px;
    // }
    &.signup_bg,&.login_bg{ 
      // background-image:url('./img/login_bg.png'); 
      @include _bg;
      border-radius: 12px;
      // border-radius: 16px;
      .closelogin-box {   
        // background-image:url('./img/login_header.png');
	      background-color: #37573f;
        background-size: cover;}
    }
    .closelogin-box {    // 登录
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      .close-btn{
        // @include common_3;
        // padding:25px 23px 0;
        .closelogin {
          @include common_2;
          position: absolute;
          z-index:1;
          right:10px;
          top:10px;
        }
      }
      .logo-show{     // 登录
        margin:0px auto;
        width:117px;
      }
    }
    .other-box{  // 其他
      @include common_1(20px);
      // text-align: center;
      // background-image: linear-gradient(90deg,#10aef7 0%,#a3eb90 100%);
      background-color: #e2bf87;
      // padding:6px 20px 13px;
      height:60px;
      padding-left:26px;
      .otherclose{
        position: absolute;
        z-index:1;
        right:10px;
        top:10px;
        @include common_2;
      }
    }
    .dia-content{
      padding:30px 20px 0;
      // background:#fff;
      border-bottom-left-radius:$border;
      border-bottom-right-radius:$border;
    }
  }
}
</style>

<style lang="scss">
.vistable_dialog{
  &.el-dialog{ background:transparent!important; }
   .el-dialog__header,.el-dialog__body{ padding:0!important;}
}
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/common/dialogTem.vue